import React from "react";


import { Asset } from "src/types/assets";
import AuthService from "src/utils/auth.service";


import ExcelViewer from "./excelViewer";

import _ from "lodash";
import cx from "classnames";
import styles from "./assetViewer.module.scss";

const DefaultAssetIcon = '/images/defaultIcons/default_asset.jpg'
interface DefaultViewerProps {
  asset: Asset;
}

const DefaultViewer = ({ asset }: DefaultViewerProps) => {

  const icon = asset.icon ? asset.icon.thumbnail : DefaultAssetIcon;

  const handleDownloadClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();

    if (!asset) {
      return false;
    }

    const url: any = AuthService.getURL(`api/2.0/assets/${asset.id}/download`, {
      modifiedDate: _.get(asset, "metadata.modified_date"), 
      _: new Date().getTime(),
    });

    if(url !== null) {
      window.open(url, "_blank");
    }
  };

  if(_.get(asset, "metadata.extension") === "xlsx") {
    return (
      <ExcelViewer asset={asset} />
    )
  }

  return (
    <div className={styles.defaultViewer}>
      <div className={styles.icon}>
        <img src={icon} />
      </div>
      <div className={styles.message}>Click here to download this file</div>
      <div className={styles.name}>{asset.name}</div>
      <a
        onClick={(e) => handleDownloadClick(e)}
        className={styles.downloadButton}
      >
        Download
      </a>
    </div>
  );
};

export default DefaultViewer;
